export const NAME_REGEX = /^[A-Za-z ]+$/;
export const PINCODE_REGEX = /^\d{6}$/;
export const MOBILE_REGEX = /^\d{10}$/;
export const EPIN_REGEX = /^\d{6}$/;